import script from "./SobreZima.vue?vue&type=script&setup=true&lang=js"
export * from "./SobreZima.vue?vue&type=script&setup=true&lang=js"

import "./SobreZima.vue?vue&type=style&index=0&id=7e808f0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e808f0b"]])

export default __exports__